export const COOKIE_CONSENT_KEY = 'sb-cookie-consent';
export const ANALYTICS_CONSENT_KEY = 'sb-analytics-consent';

const ACCEPTED_VALUE = 'accepted';
const REJECTED_VALUE = 'rejected';

export type AnalyticsConsentState = 'accepted' | 'rejected' | 'unset';

export function isCookieConsentAccepted(): boolean {
  try {
    return window.localStorage.getItem(COOKIE_CONSENT_KEY) === ACCEPTED_VALUE;
  } catch {
    return false;
  }
}

export function getAnalyticsConsent(): AnalyticsConsentState {
  try {
    const value = window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
    if (value === ACCEPTED_VALUE) return 'accepted';
    if (value === REJECTED_VALUE) return 'rejected';
    return 'unset';
  } catch {
    return 'unset';
  }
}

export function isAnalyticsConsentGranted(): boolean {
  return getAnalyticsConsent() === 'accepted';
}

/** Necessary cookies + optional analytics acceptance. */
export function acceptAllCookieConsent(): void {
  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, ACCEPTED_VALUE);
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, ACCEPTED_VALUE);
  } catch {
    // best-effort
  }
}

/** Necessary cookies only; declines commercial analytics. */
export function acceptNecessaryCookieConsentOnly(): void {
  try {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, ACCEPTED_VALUE);
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, REJECTED_VALUE);
  } catch {
    // best-effort
  }
}

/** @deprecated Use acceptAllCookieConsent */
export function acceptCookieConsent(): void {
  acceptAllCookieConsent();
}

export function rejectAnalyticsConsent(): void {
  try {
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, REJECTED_VALUE);
    window.localStorage.removeItem('sb-analytics-visitor-id');
  } catch {
    // best-effort
  }
}
